import React from 'react'
import { ReactComponent as Insights } from '../../assets/ic_insights.svg';

const InsightsIcon = () => <Insights />;

export default InsightsIcon;
